<template>
  <div style="min-height: calc(100vh - 70px);display: flex; flex-direction: column">
    <div class="m-subheader position-absolute">
      <div class="d-flex align-items-center">
        <div class="mr-auto">
          <router-link class="go-back-link" :to="{ name: 'wallet-transactions' }">
            <i class="la la-arrow-left fa-2x m--padding-15"></i>
          </router-link>
        </div>
      </div>
    </div>
    <section class="m-content m-content-full align-items-center transaction-detail">
      <div class="gate_center col">
        <div class="row justify-content-center">
          <div class="col-xl-5 col-lg-6 col-md-7 col-xs-9 col-sm-12" v-if="item ">
            <div ref="printMe" class="widget">
              <div class="detail-header">
                <div class="image-holder">
                  <img
                    src="./../../../../static/media/demo/default/img/logo/carbon_primary_positive_RGB.png"
                    alt
                    class="image-responsive image-full"
                  />
                </div>
                <div
                  class="amount"
                  :class="item.transactionType==='CREDIT'?'status-SUCCESS':'status-FAILED'"
                >
                  &#8358;{{(parseFloat(item.amount)/100).toLocaleString('en', {
                  minimumFractionDigits: 2,
                  maximumFractionDigits: 2})}}
                </div>
                <div class="type">{{item.transactionType}}</div>
                <div class="description">{{item.description}}</div>
                <div class="to">CARBON WALLET</div>
              </div>
              <div class="detail-body">
                <div class="date">
                  <div class="detail-key">DATE/TIME</div>
                  <div class="detail-value">{{moment(item.entryDate).format('MM/DD/YYYY, LT')}}</div>
                </div>
                <div class="uniqueRef">
                  <div class="detail-key">TRANSACTION ID</div>
                  <div class="detail-value">{{item.uniqueRef}}</div>
                </div>
                <div v-if="transaction" class="method">
                  <div class="left">
                    <div class="detail-key">PAYMENT METHOD</div>
                    <div
                      class="detail-value"
                    >{{transaction.serviceName === 'wallet'?'Carbon Wallet':transaction.paymentInstrument.maskedReference}}</div>
                  </div>
                  <div class="right" v-if="transaction">
                    <i class="payment-method-addcard">
                      <img
                        v-if="transaction.serviceName === 'wallet'"
                        class="payment-method-addcard-icon"
                        src="./../../../../static/media/demo/default/img/misc/carbonCard.png"
                      />
                      <img
                        v-else-if="transaction.paymentInstrument.metadata.card_type == 'visa'"
                        class="payment-method-addcard-icon"
                        src="./../../../../static/media/demo/default/img/misc/card-visa.png"
                      />
                      <img
                        v-else-if="transaction.paymentInstrument.metadata.card_type == 'verve'"
                        class="payment-method-addcard-icon"
                        src="./../../../../static/media/demo/default/img/misc/card-verve.png"
                      />
                      <img
                        v-else
                        class="payment-method-addcard-icon"
                        src="./../../../../static/media/demo/default/img/misc/card.png"
                      />
                    </i>
                  </div>
                </div>
              </div>
              <div
                class="detail-footer"
              >Get more with Carbon! Send money from your wallet to any Nigerian bank account for just N10, and renew your TV subscription for free!</div>
            </div>
          </div>
          <div class="clear"></div>
          <img hidden v-if="output" :src="output" />
          <div class="col-12 text-center m--margin-top-30">
            <button @click="print()" class="btn btn-primary m-btn--wide">Download</button>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import vue from "vue";
import VueHtml2Canvas from "vue-html2canvas";
// import { getPaymentStatus } from "./../../../api/billing/billingService";
vue.use(VueHtml2Canvas);

export default {
  props: {
    item: {
      default: null
    }
  },
  data: () => ({
    isPrinting: false,
    output: null,
    transaction: null
  }),
  components: {},
  mounted() {
    $("html, body").animate({ scrollTop: 0 }, "slow");    
    if (this.item === null) {
      this.$router.push({ name: "wallet-transactions" });
    } else {
      // this.$store.dispatch("loader", true);
      // getPaymentStatus(this.item.uniqueRef)
      //   .then(response => {
      //     if (response.response.data !== undefined) {
      //       this.transaction = response.response.data;
      //     }
      //   })
      //   .catch(error => {
      //     this.$store.dispatch("handleError", {
      //       response: error,
      //       can_cancel: true
      //     });
      //   })
      //   .finally(() => {
      //     this.$store.dispatch("loader", false);
      //   });
    }
  },
  methods: {
    async print() {
      this.isPrinting = true;
      this.$store.dispatch("loader", true);
      const el = this.$refs.printMe;
      // add option type to get the image version
      // if not provided the promise will return
      // the canvas.
      const options = {
        type: "dataURL"
      };
      this.output = await this.$html2canvas(el, options);
      this.saveAs(
        this.output,
        `Carbon (Paylater)_receipt-${this.item.uniqueRef}.png`
      );
      this.isPrinting = false;
      this.$store.dispatch("loader", false);
    },
    saveAs(uri, filename) {
      var link = document.createElement("a");
      if (typeof link.download === "string") {
        link.href = uri;
        link.download = filename;
        //Firefox requires the link to be in the body
        document.body.appendChild(link);
        //simulate click
        link.click();
        //remove the link when done
        document.body.removeChild(link);
      } else {
        window.open(uri);
      }
    }
  }
};
</script>